var render, staticRenderFns
import script from "./MarkerMaker.vue?vue&type=script&lang=js&"
export * from "./MarkerMaker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('607fa84c')) {
      api.createRecord('607fa84c', component.options)
    } else {
      api.reload('607fa84c', component.options)
    }
    
  }
}
component.options.__file = "src/components/Makers/MarkerMaker.vue"
export default component.exports